module.exports = __webpack_public_path__ + "static/media/menu.2063c35f.svg";